var alertFallback = true;
if (typeof console === "undefined" || typeof console.log === "undefined") {
    console = {};
    if (alertFallback) {
        console.log = function(msg) {
//            alert(msg);
        };
    } else {
        console.log = function() {};
    }
}

videoBg = new nc.ui.BackgroundMovie( $('.movie'), {
	url: 'http://vodfile.ncsoft.co.kr/ncvod/plaync/aion/0628_aion_5.8update_bg_mov_0616_high.mp4',
	movieW: 1920, movieH: 1080,
	selector: 'section1Video', videoControl: 'preload="auto" muted="muted"',
	stateCallback: function(state) {
		if (state == 'ended') {
			videoBg.play();
		}
	}
});

(function($){
    //sns share
    var shareUrl = '';
    var shareText_fb = '';
    var shareText_tw = '';
    var shareText_ka = '';

    shareUrl = encodeURIComponent(location.href);
    shareText_fb = "http://www.facebook.com/share.php?u=" + shareUrl;
    shareText_tw = "http://twitter.com/home?status=" + encodeURIComponent($('title').text()) + " " + shareUrl;
    shareText_ka = 'https://story.kakao.com/share?url=' + shareUrl;

    $('.facebook').click(function(event){
        event.preventDefault();
        console.log(shareUrl)
        window.open(shareText_fb);
    });

    $('.twitter').click(function(event){
        event.preventDefault();
        console.log(shareUrl)
        window.open(shareText_tw);
    });

    $('.btn-kakao').click(function(event){
        event.preventDefault();
        window.open(shareText_ka);
    });

})(jQuery);

(function(){
    var _staticPath = function(){
		var loc = location.href;
		var path = 'http://static.plaync.co.kr';
		var projectPath = '/promo/aion/update/2017/update_170628/img/';
		if(/rc\./i.test(loc)){
			path = 'http://rc.static.plaync.co.kr';
		}
		if(/local\.|localhost|opdev\.|ui-static\.|file:/i.test(loc)){
			path = 'http://ui-static.korea.ncsoft.corp';
		}
		return path + projectPath;
	}();
    var imgList = [
		_staticPath + 'btn_line_lastbottom.png',
		_staticPath + 'btn_line_lasttop.png',
		_staticPath + 'btn_line_leftbottom.png',
        _staticPath + 'btn_line_lefttop.png',
        _staticPath + 'btn_line_rightbottom.png',
        _staticPath + 'btn_line_righttop.png',
        _staticPath + 'btn_list1_off.png',
        _staticPath + 'btn_list1_on.png',
        _staticPath + 'btn_list2_off.png',
		_staticPath + 'btn_list2_on.png',
        _staticPath + 'btn_list3_off.png',
		_staticPath + 'btn_list3_on.png',
		_staticPath + 'btn_list4_off.png',
        _staticPath + 'btn_list4_on.png',
        _staticPath + 'btn_play.png',
        _staticPath + 'copyright.png',
        _staticPath + 'etc_txt.png',
        _staticPath + 'loading_bg.png',
        _staticPath + 'loading_bi.jpg',
		_staticPath + 'logo.png',
        _staticPath + 'mask.png',
		_staticPath + 'sns.png',
		_staticPath + 'teaser_tit.png',
        _staticPath + 'teaser_txt1.png',
        _staticPath + 'teaser_txt2.png',
        _staticPath + 'teaser_txt3.png',
        _staticPath + 'teaser_txt_date.png',
        _staticPath + 'triangle.png'
	];
	var isInitialized = false;
	var $loader;
	var $backDrop;
	var loadedImgArr = [];
	var imgURLArr = imgList;
	var loadingIndex = 0;
	var loadFailNum = 0;
	var percentageLoaded = 0;
	var completeCallback;

	function loadingStart(_loadCompleteCallback){
		if(!isInitialized){
			isInitialized = true;
			completeCallback = _loadCompleteCallback;
			loadNext();
		}
	}

	function loadNext(){
		setTimeout(function(){
			if(loadingIndex >= imgURLArr.length){
                NCNS.init();
				return;
			}
			var _img = document.createElement("img");
			_img.onload = loadCompleteHandler;
			_img.onerror = loadErrorHandler;
			_img.src = imgURLArr[loadingIndex];
		}, 100);
	}

	function loadCompleteHandler(){
        if(this) loadedImgArr.push(this);
        loadingIndex++;
        percentageLoaded = loadingIndex / imgURLArr.length * 100+"%";
        console.log(loadingIndex+"|"+percentageLoaded)
        $(".loading_bg2").css({height:percentageLoaded});
        loadNext();
	}

	function loadErrorHandler(event){
		var _img = event.target;
		loadedImgArr.push(null);
		loadFailNum++;
		loadingIndex++;
		percentageLoaded = Math.floor((loadingIndex / imgURLArr.length) * 100);
		loadNext();
	}

    loadingStart();
}());

var NCNS = (function(NCNS, $, undefined){

    var youtube = $(".youtube_wrap");

    NCNS.init = function(){
        videoBg.play();
        TweenMax.to([$(".loading_bg")], 1.0, {alpha:0, onComplete:loadComplete});
        TweenMax.to([$(".container")], 1.0, {alpha:1});
        teaserV2();
    };

    function loadComplete(){
        $(".loading_bg").remove();
    }

    function teaserV2(){
        var btnObj = [$(".list_bg1").find("a"), $(".list_bg2").find("a"), $(".list_bg3").find("a"), $(".list_bg4").find("a")];
        var mv2 = new TimelineLite({paused: true});
    		mv2.from([$(".list_bg1").find(".bg1")], 0.3, {x:60, y:-60, alpha:0, ease:Sine.Power1}, "+=1.0")
            .from([$(".list_bg1").find(".bg2")], 0.3, {x:60, y:60, alpha:0, ease:Sine.Power1}, "-=0.2")
            .from([$(".list_bg1").find(".bg4")], 0.3, {x:-60, y:60, alpha:0, ease:Sine.Power1}, "-=0.2")
            .from([$(".list_bg1").find(".bg3")], 0.3, {x:60, y:60, alpha:0, ease:Sine.Power1}, "-=0.2")
            .from([$(".list_bg2").find(".bg2")], 0.3, {x:60, y:60, alpha:0, ease:Sine.Power1}, "-=0.2")
            .from([$(".list_bg2").find(".bg4")], 0.3, {x:-60, y:60, alpha:0, ease:Sine.Power1}, "-=0.2")
            .from([$(".list_bg3").find(".bg2")], 0.3, {x:60, y:60, alpha:0, ease:Sine.Power1}, "-=0.2")
            .from([$(".list_bg3").find(".bg4")], 0.3, {x:-60, y:60, alpha:0, ease:Sine.Power1}, "-=0.2")
            .from([$(".list_bg4").find(".bg5")], 0.3, {x:60, y:60, alpha:0, ease:Sine.Power1}, "-=0.2")
            .from([$(".list_bg4").find(".bg6")], 0.3, {x:-60, y:60, alpha:0, ease:Sine.Power1}, "-=0.2")
            .staggerFrom([
                $(".list_bg1").find("a"),
                $(".list_bg2").find("a"),
                $(".list_bg3").find("a"),
                $(".list_bg4").find("a")
            ], 0.5, {x:50, y:50, alpha:0, ease:Sine.Power1}, 0.2)
            .from([$(".teaser_tit")], 1.0, {y:70, alpha:0, ease:Circ.easeOut}, "-=0.1")
            .from([$(".btn_logo")], 0.7, {y:-100, alpha:0}, "-=0.7")
            .from([$(".footer")], 0.7, {y:100, alpha:0}, "-=0.7");
        mv2.play();
        console.log("v2")
    }

    return NCNS;

})(window.NCNS || {},jQuery);
